// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ab80fb62","488":"2ecc3740"}[chunkId] + ".chunk.js";
};